import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var CurrencyIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0438 15.661C13.0438 10.3096 18.1327 6.27429 24.0088 6.27429C26.5702 6.27429 29.2743 7.14814 31.3574 8.73586C33.454 10.3339 34.9739 12.7045 34.9739 15.661C34.9739 16.2395 34.5049 16.7086 33.9263 16.7086C33.3477 16.7086 32.8787 16.2395 32.8787 15.661C32.8787 13.491 31.7795 11.6921 30.0873 10.4022C28.3814 9.10202 26.1269 8.36952 24.0088 8.36952C18.9339 8.36952 15.139 11.7932 15.139 15.661C15.139 17.0262 15.4173 18.0482 15.8582 18.8394C16.299 19.6305 16.9368 20.2524 17.7485 20.7661C19.4239 21.8261 21.7051 22.3548 24.2347 22.9314L24.3077 22.9481C26.7167 23.4972 29.3585 24.0994 31.3808 25.396C32.4276 26.0672 33.3369 26.939 33.9784 28.1042C34.6196 29.2689 34.9599 30.6662 34.9599 32.3391C34.9599 37.6904 29.871 41.7257 23.9949 41.7257C18.1187 41.7257 13.0298 37.6904 13.0298 32.3391C13.0298 31.7605 13.4988 31.2914 14.0774 31.2914C14.656 31.2914 15.125 31.7605 15.125 32.3391C15.125 36.2068 18.9199 39.6305 23.9949 39.6305C29.0698 39.6305 32.8647 36.2068 32.8647 32.3391C32.8647 30.9564 32.5856 29.9188 32.1429 29.1147C31.7004 28.311 31.0612 27.6801 30.2498 27.1598C28.5761 26.0867 26.2958 25.5503 23.769 24.9743C23.7227 24.9637 23.6762 24.9531 23.6297 24.9425C21.2414 24.3984 18.6303 23.8034 16.6283 22.5367C15.5818 21.8746 14.671 21.0134 14.0279 19.8593C13.3848 18.7052 13.0438 17.3198 13.0438 15.661Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0088 2C24.5874 2 25.0565 2.46904 25.0565 3.04762V44.9524C25.0565 45.531 24.5874 46 24.0088 46C23.4303 46 22.9612 45.531 22.9612 44.9524V3.04762C22.9612 2.46904 23.4303 2 24.0088 2Z"
  }));
});
CurrencyIcon.displayName = 'CurrencyIcon';
CurrencyIcon.defaultProps = {
  'aria-label': 'Currency'
};
export default CurrencyIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/CurrencyIcon/index.js
// module id = 1822
// module chunks = 12